import PropTypes from "prop-types";
import {useRouter} from "next/router";
import Image from "next/image";
import SocialBlock from "./SocialBlock";

const InfoBlockBlog = ({author, image, date}) => {
  const {basePath} = useRouter();

  return (
    <div className="page-blog__info-block">
      <div className="page-blog_left-block">
        <Image className="page-blog__author-image" src={`${basePath}/images/${image}`}
               width={48} height={48} alt=""/>
        <div className="page-blog_block">
          <p className="page-blog__small-text">{author}</p>
          <p className="page-blog__date">{date}</p>
        </div>
      </div>
      <SocialBlock/>
    </div>
  );
};

InfoBlockBlog.propTypes = {
  image: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};

export default InfoBlockBlog;
